var map = {
	".": 7761,
	"./": 7761,
	"./admin": 8717,
	"./admin/": 8717,
	"./admin/admininfo": 9958,
	"./admin/admininfo.js": 9958,
	"./admin/allusers": 4757,
	"./admin/allusers.js": 4757,
	"./admin/component": 5041,
	"./admin/component.js": 5041,
	"./admin/createtransaction": 1336,
	"./admin/createtransaction/": 1336,
	"./admin/createtransaction/changewallet": 2767,
	"./admin/createtransaction/changewallet.js": 2767,
	"./admin/createtransaction/createtransaction": 3182,
	"./admin/createtransaction/createtransaction.js": 3182,
	"./admin/createtransaction/index": 1336,
	"./admin/createtransaction/index.js": 1336,
	"./admin/createtransaction/usertransaction": 9674,
	"./admin/createtransaction/usertransaction.js": 9674,
	"./admin/index": 8717,
	"./admin/index.js": 8717,
	"./admin/setwallet": 1785,
	"./admin/setwallet.js": 1785,
	"./admin/transactions": 6914,
	"./admin/transactions.js": 6914,
	"./admin/whatsapp": 1677,
	"./admin/whatsapp.js": 1677,
	"./allcoins": 3467,
	"./allcoins.js": 3467,
	"./allcoinsaction": 8496,
	"./allcoinsaction.js": 8496,
	"./authentication": 6400,
	"./authentication/": 6400,
	"./authentication/directlogin": 6235,
	"./authentication/directlogin.js": 6235,
	"./authentication/index": 6400,
	"./authentication/index.js": 6400,
	"./authentication/login": 4319,
	"./authentication/login.js": 4319,
	"./authentication/logo": 2053,
	"./authentication/logo.js": 2053,
	"./authentication/phraselogin": 8335,
	"./authentication/phraselogin.js": 8335,
	"./authentication/resetpassword": 1966,
	"./authentication/resetpassword.js": 1966,
	"./authentication/signup": 7286,
	"./authentication/signup.js": 7286,
	"./authentication/signupbackup": 4857,
	"./authentication/signupbackup.js": 4857,
	"./authentication/uploadid": 5845,
	"./authentication/uploadid.js": 5845,
	"./coin": 2300,
	"./coin.js": 2300,
	"./connectwallet": 1512,
	"./connectwallet.js": 1512,
	"./images/coins/bnb.png": 5413,
	"./images/coins/bnb.svg": 7923,
	"./images/coins/btc.png": 9902,
	"./images/coins/btc.svg": 8591,
	"./images/coins/eth.png": 8619,
	"./images/coins/eth.svg": 4629,
	"./images/coins/tron.png": 9251,
	"./images/coins/trx.svg": 529,
	"./images/coins/usdt(erc20).svg": 1192,
	"./images/coins/usdt.png": 4091,
	"./images/coins/usdt.svg": 2569,
	"./index": 7761,
	"./index.js": 7761,
	"./phrase": 1136,
	"./phrase.js": 1136,
	"./profile": 9068,
	"./profile.js": 9068,
	"./recievemodal": 4701,
	"./recievemodal.js": 4701,
	"./send": 9809,
	"./send.js": 9809,
	"./settings": 4618,
	"./settings.js": 4618,
	"./styles.scoped.css": 2700,
	"./transactionhistory": 1702,
	"./transactionhistory.js": 1702,
	"./verification": 9313,
	"./verification/": 9313,
	"./verification/index": 9313,
	"./verification/index.js": 9313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9100;